export const UPDATE_PASSWORD = 'UPDATE_PASSWORD'
export const UPDATE_PASSWORD_PENDING = 'UPDATE_PASSWORD_PENDING'
export const UPDATE_PASSWORD_FULFILLED = 'UPDATE_PASSWORD_FULFILLED'
export const UPDATE_PASSWORD_REJECTED = 'UPDATE_PASSWORD_REJECTED'

export const CHANGE_PASSWORD_FIELD = 'CHANGE_PASSWORD_FIELD'